import React from 'react';

/**
 * Animated circular gauge for AI insight scores.
 * Props: value (0-100), label, suffix?, icon? (LucideIcon), accent? (hex)
 */
const ScoreGauge = ({ value, label, suffix = '', icon: Icon, accent = '#D4FF00', size = 96, testid }) => {
  const v = Math.max(0, Math.min(100, value || 0));
  const radius = (size - 12) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (v / 100) * circumference;
  return (
    <div className="flex flex-col items-center gap-2" data-testid={testid}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle
            cx={size / 2} cy={size / 2} r={radius}
            stroke="rgba(255,255,255,0.06)" strokeWidth="6" fill="transparent"
          />
          <circle
            cx={size / 2} cy={size / 2} r={radius}
            stroke={accent} strokeWidth="6" fill="transparent"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            style={{ transition: 'stroke-dashoffset 1s ease-out' }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          {Icon && <Icon className="w-3.5 h-3.5 mb-0.5" style={{ color: accent }} />}
          <span className="font-heading font-black text-xl" style={{ color: accent }}>
            {v}{suffix}
          </span>
        </div>
      </div>
      <span className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">{label}</span>
    </div>
  );
};

export default ScoreGauge;
